module.exports = __webpack_public_path__ + "assets/1b4389cd7ec380ec5553e6da45d9cd80.mp3";